module.exports = __webpack_public_path__ + "static/media/sms-confirmation-icon.41641e14.svg";